import { Services } from '@sigma-frontend-libs/commons'

import { filterByData } from '@/components/services/report-manager/utils'

import render from './render'

export default {
  name: 'FilterByTags',

  mixins: [ filterByData ],

  computed: {
    formatItems() {
      return Object.entries(this.items).map(([ key, value ]) => {
        return {
          value,
          label: [ this.getTranslate(`${Services['report-manager']}.labels.${this.value.type}.${key}`), ':' ].join(''),
          loading: this.loadingItems.includes(key)
        }
      })
    },

    rows() {
      return [
        this.formatItems.slice(0, Math.ceil(this.formatItems.length / 2)),
        this.formatItems.slice(Math.ceil(this.formatItems.length / 2), this.formatItems.length)
      ]
    }
  },

  render
}
